var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRightSm = function SvgChevronRightSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "chevron-right-sm_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m24.21 18.123-1.425 1.425 6.726 6.726L36.237 33l-6.726 6.726-6.726 6.726 1.425 1.425 1.425 1.425 8.151-8.151L41.937 33l-8.151-8.151-8.151-8.151z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronRightSm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI0LjIxIDE4LjEyMjlMMjIuNzg1MyAxOS41NDgxTDI5LjUxMTEgMjYuMjc0TDM2LjIzNyAzMi45OTk5TDI5LjUxMSAzOS43MjU5TDIyLjc4NTIgNDYuNDUxOUwyNC4yMTAyIDQ3Ljg3NjlMMjUuNjM1MiA0OS4zMDE5TDMzLjc4NjEgNDEuMTUwOUw0MS45MzcgMzIuOTk5OUwzMy43ODU5IDI0Ljg0ODhMMjUuNjM0OSAxNi42OTc4TDI0LjIxIDE4LjEyMjlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";